import React from "react";
import styles from "./Table.module.sass";
import Loader from "../Loader";
import Row from "./Row";
import { Pager } from "../Pager";
import Empty from "../Empty";

const Table = ({ items, title, isLoading, fetchCollections, ...rest }) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.table}>
				<div className={styles.row}>
					<div className={styles.col}>
						{/* <Checkbox
							className={styles.checkbox}
							value={chooseAll}
							onChange={() => setСhooseAll(!chooseAll)}
						/> */}
					</div>
					<div className={styles.col}>Drop name</div>
					{/* <div className={styles.col}>Price</div> */}
					<div className={styles.col}>{title}</div>
					<div className={styles.col}>Created</div>
				</div>
				{items.map((x) => (
					<Row item={x} key={x._id} fetchCollections={fetchCollections} />
				))}
			</div>
			{!isLoading && items.length === 0 && <Empty />}
			{isLoading && <Loader className={styles.loader} />}
			<div className={styles.foot}>
				<Pager {...rest} />
			</div>
		</div>
	);
};

export default Table;
